module.exports = __webpack_public_path__ + "static/media/side-bed.47b1ea96.svg";